import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useEffect, useMemo } from "react";
import {
  I18nContext,
  dict,
  isActiveLocale,
  RTL_LOCALES,
  type Lang,
} from "@/lib/i18n";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AgeGate } from "@/components/site/AgeGate";

export const Route = createFileRoute("/$lang")({
  beforeLoad: ({ params }) => {
    if (!isActiveLocale(params.lang)) {
      throw redirect({ to: "/$lang", params: { lang: "en" } });
    }
  },
  component: LangLayout,
});

function LangLayout() {
  const { lang } = Route.useParams();
  const value = useMemo(() => ({ lang: lang as Lang, t: dict[lang as Lang] }), [lang]);

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL_LOCALES.has(lang as Lang) ? "rtl" : "ltr";
  }, [lang]);

  return (
    <I18nContext.Provider value={value}>
      <div className="flex min-h-screen flex-col bg-background text-foreground">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <AgeGate lang={lang} />
      </div>
    </I18nContext.Provider>
  );
}